export default __webpack_public_path__ + "static/media/Capture2.5bb2f7cb.PNG";